import React, {useEffect} from 'react';
import {usePosition} from 'use-position';
import {useDispatch} from "react-redux";
import {changeUserLocation} from "../../store/actions/AuthActions";

const GetLocation = ({follow, onLocationChange}) => {
  const dispatch = useDispatch();
  const { latitude, longitude } = usePosition(!!follow, {enableHighAccuracy: true});

  useEffect(() => {
    if (!!latitude && !!longitude) {
      dispatch(changeUserLocation({ lat: latitude, lng: longitude }));
      if (!!onLocationChange) {
        onLocationChange({latitude, longitude});
      }
    }
  }, [latitude, longitude]);

  return null;
};

export default GetLocation;
